import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIntroComponent } from './mat-intro.component';
import { MatIntroService } from './mat-intro.service';
import { MatCardModule } from '@angular/material/card';
import { MatUserPictureModule } from '../mat-user-picture/mat-user-picture.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatIntroOptions } from './mat-intro.service';
import { MatIntroHelperComponent } from './mat-intro-helper.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '@lib/shared.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    MatIntroComponent,
    MatIntroHelperComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatUserPictureModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    SharedModule
  ],
  exports: [
    MatIntroHelperComponent
  ]
})
export class MatIntroModule { }

export {MatIntroService as MatIntro, MatIntroOptions};